import { combineReducers } from '@reduxjs/toolkit';
import displayReducer from './reducers/display/slice';
import validationReducer from './reducers/validation/slice';
import customerReducer from './reducers/customer/slice';
import tagsReducer from './reducers/tags/slice';
import bookingTimesReducer from './reducers/bookingTimes/slice';
import activeBookingsReducer from './reducers/activeBookings/slice';
import activeLayoutsReducer from './reducers/activeLayouts/slice';
import activeSectionsReducer from './reducers/activeSections/slice';
import tablesReducer from './reducers/tables/slice';
import bookingOptionsUpsellReducer from './reducers/bookingOptionsUpsell/slice';
import paymentReducer from './reducers/payment/slice';
import standbyReducer from './reducers/standbyList/slice';
import recurringBooking from './reducers/recurringBooking/slice';
import communicationReducer from './reducers/communication/slice';
import scrollPositionReducer from './reducers/scrollPosition/slice';
import activeScheduleReducer from './reducers/activeSchedule/slice';
import bookingCreatorSettingReducer from './reducers/setting/slice';
import transitionReducer from './reducers/transition/slice';
import cancelConfirmReducer from './reducers/cancelConfirm/slice';
import staffValidationReducer from './reducers/staffValidation/slice';

export const bookingCreatorReducers = {
  displayReducer,
  validationReducer,
  customerReducer,
  tagsReducer,
  bookingTimesReducer,
  activeBookingsReducer,
  activeLayoutsReducer,
  activeSectionsReducer,
  tablesReducer,
  bookingOptionsUpsellReducer,
  paymentReducer,
  standbyReducer,
  staffValidationReducer,
  recurringBooking,
  communicationReducer,
  scrollPositionReducer,
  activeScheduleReducer,
  bookingCreatorSettingReducer,
  transitionReducer,
  cancelConfirmReducer,
};

const rootReducer = combineReducers(bookingCreatorReducers); // just used to create type BookingCreatorState

export type BookingCreatorState = ReturnType<typeof rootReducer>;

/**
 * Don't need to export the rootReducer because it will be consumed by a parent app with its own rootReducer
 */
// export default rootReducer;
